export default __webpack_public_path__ + "static/media/arow-up.162b13ac.svg";